import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { showToast } from "../ToastManager";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";

import ConfigsService from '../../service/ConfigsService';

const configService = new ConfigsService(); // Create an instance of PrestadorService

const ListarRoles = () => {
    const [role, setRole] = useState([]);
    const [filters1, setFilters1] = useState(null);
    const [loading1, setLoading1] = useState(false);
    const history = useHistory();
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [toDelete, setToDelete] = useState(null);

    const iss = localStorage.getItem('iss');
    let roles = JSON.parse(localStorage.getItem('roles'));

    useEffect(() => {
        initFilters1();
        initRole();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps


    const initRole = () => {
        setLoading1(true);
        configService.listAllRoles(iss).then(data => {
            setRole(data.data.rows);
            setLoading1(false);
        });
    }

    const initFilters1 = () => {
        setFilters1({
            'nome': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            'descricao': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        });
    }

    const irParaCadastro = () => {
        if (roles.postRole)
            history.push('/roles/cadastrar');
    }

    const abreModalDeletar = (toDelete) => {
        setToDelete(toDelete);
        setDeleteDialog(true);
    }

    const handleDelete = () => {
        if (roles.deleteRole) {
            setLoading1(true)
            configService.deleteRole(iss, toDelete.id).then(() => {
                showToast({ severity: 'success', summary: 'Sucesso', detail: 'Perfil de acesso desativado com sucesso' });
                setLoading1(false);
                hideModalDeletar();
                initRole();
            });
        }
    }

    const editar = (toEdit) => {
        if (roles.getRole)
            history.push('/roles/editar/' + toEdit.id);
    }

    const hideModalDeletar = () => {
        setDeleteDialog(false);
        setToDelete(null);
    }

    const ativoBody = (rowData) => {
        return <span className={`p-inputgroup-addon ${rowData.ativo ? 'pi pi-check' : 'pi pi-times'} `} style={{ backgroundColor: rowData.ativo ? 'green' : 'red', color: 'black' }}></span>
    }

    const opcoesBody = (rowData) => {
        return <span style={{ display: 'flex', justifyContent: 'space-between' }}>
            {roles.deleteRole ? <Button icon="pi pi-times" onClick={() => { abreModalDeletar(rowData) }} style={{ backgroundColor: 'red', borderColor: 'red' }} className="p-button-rounded mr-2 mb-2" /> : <></>}
            {roles.getRole ? <Button icon="pi pi-pencil" onClick={() => { editar(rowData) }} className="p-button-rounded  mr-2 mb-2" /> : <></>}
        </span>
    }

    const deleteFooter = (
        <>
            <Button loading={loading1} label="Não" icon="pi pi-times" className="p-button-text" onClick={hideModalDeletar} />
            <Button loading={loading1} label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleDelete} />
        </>
    );

    return (
        <div className="grid table-demo">
            <div className="col-12">
                {roles.postRole ? <Button label="Cadastrar" onClick={irParaCadastro} className="mr-2 mb-2"></Button> : <></>}
                <div className="card">
                    <h5>Perfis de acesso</h5>
                    <DataTable value={role} paginator className="p-datatable-gridlines" showGridlines rows={10}
                        dataKey="id" filters={filters1} filterDisplay="menu" loading={loading1} responsiveLayout="scroll"
                        emptyMessage="Nenhuma perfil de acesso cadastrado.">
                        <Column sortable field="name" header="Nome" filter filterPlaceholder="Procurar por nome" style={{ minWidth: '12rem' }} />
                        <Column sortable field="description" header="Descrição" filter filterPlaceholder="Procurar por descrição" style={{ minWidth: '12rem' }} />
                        <Column sortable field="ativo" body={ativoBody} header="Ativo" style={{ width: '1rem' }} />
                        <Column header="Opções" body={opcoesBody} style={{ width: '8rem' }} />
                    </DataTable>
                </div>
            </div>

            <Dialog visible={deleteDialog} style={{ width: '450px' }} header="Desativar" modal footer={deleteFooter} onHide={hideModalDeletar}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    <span>Ao desativar esse perfil de acesso, todos os usuários vinculados a ele não terão mais acesso ao sistema. <br></br><br></br> Tem certeza que deseja desativar esse perfil de acesso selecionado?</span>
                </div>
            </Dialog >
        </div >

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(ListarRoles, comparisonFn);
